import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

type SizeValue = number | string;

export const ICON_SIZE = 22;
export const PRIMARY_COLOR = '#1010eb';

export const getContentStyles = (width: SizeValue, height: SizeValue): SxProps<Theme> => ({
  width,
  height,
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'background.paper',
  overflow: 'hidden',
});

export const filtersListStyles: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
};

export const footerStyles: SxProps<Theme> = {
  p: 2,

  '& div': {
    width: '100%',
  },
};

export const closeIconStyles = {
  width: '20px',
  height: '20px',
};

export const collapseWrapperStyles: SxProps<Theme> = {
  height: '100%',
  position: 'relative',
  zIndex: 2,
  backgroundColor: 'background.paper',
};

export const getCollapsePaperStyles = (width: SizeValue, height: SizeValue): SxProps<Theme> => ({
  width,
  height,
  position: 'relative',
  zIndex: 2,
  backgroundColor: 'background.paper',
  overflow: 'hidden',
});

export const appliedFiltersSummaryRowStyles: SxProps<Theme> = {
  width: '100%',
  backgroundColor: '#E9FAFF',
};
